import {useContext} from "react";
import {LogoHp} from "@veneer/core";
import {AuthContext} from "./auth/AuthContext";

const Header = () => {

    const authContext = useContext(AuthContext);

    const logout = async () => {
        await authContext.logout();
        window.location.replace(process.env.REACT_APP_PUBLIC_URL + "/logout");
    }

    return (
        <header>
            <div className="tableWrapper">
                <div className="row p-20-header">
                    <div className="col-md-12">
                        <table>
                            <tr>
                                <td>
                                    <LogoHp appearance="multicolor" size={40}/>
                                </td>
                                <td>
                                    <p className="pmargin">
                                        <h4>HP Supply Encoding Service
                                                <br/>
                                            Account Management</h4>
                                        </p>
                                    </td>
                                </tr>
                            </table>
                            <div>
                                <p className="email">{authContext.userEmail}</p>
                            </div>
                            <div>
                                <button onClick={ e => logout(e)} className="btn-signout"><p className="pright">Sign out</p></button>
                            </div>
                        </div>
                    </div>
                </div>
      </header>
    )
  }

export default Header;
